module.exports = {
          srcSet: __webpack_public_path__ + "images/1984-d77bd40ea09fd1c53f54c49db08a1601-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1984-65ab10b9ced0b4296277eec85351bb27-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1984-d77bd40ea09fd1c53f54c49db08a1601-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1984-65ab10b9ced0b4296277eec85351bb27-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1984-d77bd40ea09fd1c53f54c49db08a1601-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1984-d77bd40ea09fd1c53f54c49db08a1601-320.jpg"},
          
          width: 320,
          height: 251
        }